import { useRef, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { useAppPathParams } from 'utils/url/useAppPathParams';
const statusIcons = {
    none: undefined,
    success: 'check-circle-filled',
    error: 'exclamation-triangle-filled',
};
const statusResetTimeout = 3000;
/**
 * Returns an icon based on a field's update api call result. The icon will
 * reset after some seconds.
 */
export function useSaveStatusIcon() {
    const { csid } = useAppPathParams('/conversation/:csid');
    const statusTimeoutRef = useRef();
    const [iconName, setIconName] = useState();
    const setStatus = (status) => {
        setIconName(statusIcons[status]);
        if (statusTimeoutRef.current) {
            clearTimeout(statusTimeoutRef.current);
        }
        statusTimeoutRef.current = setTimeout(() => setStatus('none'), statusResetTimeout);
    };
    // Handles resetting the icon when new conversation is loaded.
    useUpdateEffect(() => {
        if (statusTimeoutRef.current) {
            clearTimeout(statusTimeoutRef.current);
        }
        setIconName(statusIcons.none);
    }, [csid]);
    return [iconName, setStatus];
}
